export const DonationCardPurchaseStatus = {
  Pending: 0,
  Paid: 1,
  Cancelled: 2,
  AwaitingApproval: 3,
};

export const DonationPaymentMethod = {
  Cash: 0,
  BankTransfer: 1,
  CreditCard: 2,
  Online: 3,
};

export const isPayTrCardPayment = (paymentMethod) =>
  paymentMethod === DonationPaymentMethod.CreditCard
  || paymentMethod === DonationPaymentMethod.Online;

export const isManualPaymentNoLogo = (paymentMethod) =>
  paymentMethod === DonationPaymentMethod.Cash
  || paymentMethod === DonationPaymentMethod.BankTransfer;

const matchesPurchase = (row, purchaseId) => {
  if (!purchaseId || !row) return false;
  return row.sourceId === purchaseId
    || row.parentSourceId === purchaseId
    || row.externalSourceId === purchaseId;
};

export const resolveDonationLogoInfo = (detail, ledgerRows = []) => {
  if (!detail) {
    return {
      debtSlipNo: null,
      collectionSlipNo: null,
      isPayTr: false,
      isManual: false,
      showLogoSection: false,
      showPendingWarning: false,
      showManualNote: false,
    };
  }

  const paymentMethod = detail.paymentMethod;
  const isPayTr = isPayTrCardPayment(paymentMethod);
  const isManual = isManualPaymentNoLogo(paymentMethod);
  const relatedRows = Array.isArray(ledgerRows)
    ? ledgerRows.filter((row) => matchesPurchase(row, detail.id))
    : [];

  const debtFromLedger = relatedRows.find(
    (row) => row.externalReference && (row.debitAmount > 0 || row.ledgerKind === 0),
  )?.externalReference;

  const collectionFromLedger = relatedRows.find(
    (row) => row.externalReference && (row.creditAmount > 0 || row.ledgerKind === 1),
  )?.externalReference;

  const debtSlipNo = detail.lastLogoDebtSlipNo
    || detail.logoDebtSlipNo
    || debtFromLedger
    || null;

  const collectionSlipNo = detail.paymentExternalReference
    || detail.externalReference
    || collectionFromLedger
    || null;

  const showPendingWarning = detail.status === DonationCardPurchaseStatus.Pending && isPayTr;
  const showManualNote = isManual || (
    detail.status === DonationCardPurchaseStatus.Paid && isManual
  );
  const showLogoSection = isPayTr && detail.status === DonationCardPurchaseStatus.Paid;

  return {
    debtSlipNo,
    collectionSlipNo,
    isPayTr,
    isManual,
    showLogoSection,
    showPendingWarning,
    showManualNote,
  };
};
